export default "__VITE_ASSET__DnA5qr3w__"